import { ReactElement } from 'react';

import { Button, ButtonVariant, TestableComponentProps } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../../../translations';

const t = patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.modal.form.table.columns.actions;

type ConsentsAndAuthorizationsDocumentsFillButtonProps = TestableComponentProps & {
   readonly onClick: VoidFunction;
};

export const ConsentsAndAuthorizationsDocumentsFillButton = (
   props: ConsentsAndAuthorizationsDocumentsFillButtonProps
): ReactElement => {
   return (
      <Button
         type={'button'}
         testId={props.testId}
         label={t.fill}
         variant={ButtonVariant.SECONDARY}
         compact
         onClick={props.onClick}
      />
   );
};
